import { render } from "./PresenterOverlay.vue?vue&type=template&id=2238218e&scoped=true"
import script from "./PresenterOverlay.vue?vue&type=script&lang=js"
export * from "./PresenterOverlay.vue?vue&type=script&lang=js"

import "./PresenterOverlay.vue?vue&type=style&index=0&id=2238218e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2238218e"]])

export default __exports__